export default __webpack_public_path__ + "static/media/press_mention_icon.a6932fdc.svg";